<template>
  <div class="input-container">
    <input
      class="input"
      v-bind="$attrs"
      :value="value"
      v-on="inputListeners" />
  </div>
</template>

<script>
export default {
  props: {
    value: String,
  },
  computed: {
    inputListeners() {
      const vm = this;
      // `Object.assign` merges objects together to form a new object
      return Object.assign(
        {},
        // We add all the listeners from the parent
        this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        {
          // This ensures that the component works with v-model
          input(event) {
            vm.$emit('input', event.target.value);
          },
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  width: 100%;
  font-size: 15px;
}
.input {
  width: 100%;
  border: 1px solid #d6d6d8;
  border-radius: 4px;
  padding: 8px 10px;
  font-size: inherit;

  &:focus {
    border: 1px solid #3479e9;
  }
}
::placeholder {
  color: #afb1b3;
}
</style>
